// extracted by mini-css-extract-plugin
export default {"SportSection":"SportSection_SportSection__r4-L1"};